import React, {useState, useCallback} from 'react';
import t from 'babel-plugin-yate/macro';
import {Form, Field} from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import AcordBC from '../../assets/AcordBCProcesareDate_Credex_20241101_2.pdf';
import AcordGDPR from '../../assets/AcordGDPR_Credex_20250403.pdf';

import {Text} from '../../components/uiElem';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import Checkbox from '../../components/Form/Checkbox';
import {isRequired} from '../../lib/validations';
import ContactMode from '../../containers/ContactMode';
import {DocPreview, DocRow} from '../DocPreview/previewHelpers';

function ModalConsentCreditBureau(props) {
  const {id, patchHandler, data} = props;
  const [btnDisabled, setBtnDisabled] = useState(true);

  const enableBtn = useCallback(() => {
    setBtnDisabled(false);
  }, []);

  return (
    <Modal id={id} header={t`Agreements`} width="max-w-lg" allowClose={false}>
      <DocPreview onSuccess={enableBtn} />
      <DocRow
        fileName={t`Acord de consultare a informatiilor la Biroul de Credit`}
        url={AcordBC}
        isDefault
      />
      <DocRow
        fileName={t`Acord de prelucrare a datelor personale de catre Credex IFN`}
        url={AcordGDPR}
      />

      <Form
        keepDirtyOnReinitialize={true}
        onSubmit={patchHandler}
        initialValues={{
          customer: null,
          tombola: data.current_tombola
            ? {
                agreed: false,
                tombola_id: data.current_tombola.id,
              }
            : null,
        }}
        mutators={arrayMutators}
        render={({handleSubmit}) => (
          <form onSubmit={handleSubmit}>
            <div className="p-4 border-t">
              <div>
                <Field
                  name="customer.agreement.has_cb_interrogation_consent"
                  label={t`Prin bifarea acestei casute sunt de acord ca Credex IFN sa foloseasca datele mele personale si sa le transmita la Biroul de Credit.`}
                  component={Checkbox}
                  type="checkbox"
                  validate={isRequired()}
                  parse={value => (value === true ? value : undefined)}
                />
              </div>

              <div className="pt-3">
                <Field
                  name="customer.agreement.has_personal_data_consent"
                  label={t`Prin bifarea acestei casute sunt de acord ca Credex IFN sa prelucreze datele mele personale in scopul acordarii unui credit.`}
                  component={Checkbox}
                  type="checkbox"
                  validate={isRequired()}
                  parse={value => (value === true ? value : undefined)}
                />
              </div>

              <div className="pt-3">
                <Field
                  name="customer.agreement.has_marketing"
                  label={t`Sunt de acord ca Credex IFN sa prelucreze datele mele personale in scop de marketing si sa transmita oferte personalizate prin urmatoarele canale:`}
                  component={Checkbox}
                  type="checkbox"
                />

                <ContactMode />
              </div>

              {data.current_tombola && (
                <div className="pt-3 flex">
                  <Field
                    name="tombola.agreed"
                    label={t`Sunt de acord sa particip la campania "${data.current_tombola.name}".`}
                    component={Checkbox}
                    type="checkbox"
                  />

                  {data.current_tombola.regulations_document_link && (
                    <div className="ml-1">
                      <Text ui="venus">
                        <a
                          href={data.current_tombola.regulations_document_link}
                          target="_blank"
                          rel="noopener noreferrer">
                          {t`Vezi regulament`}
                        </a>
                      </Text>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="p-4 border-t text-center">
              <div className="w-64 mx-auto">
                <Button
                  fullWidth
                  color="orange"
                  border={false}
                  title={t`Continue`}
                  customProps={{type: 'submit', disabled: btnDisabled}}
                />
              </div>

              <div className="py-3">
                <Text ui="earth">
                  {t`Va rugam sa consultati acordul de prelucrare date si consultare Birou de Credit inainte de a continua.`}
                </Text>
              </div>
            </div>
          </form>
        )}
      />
    </Modal>
  );
}

export default ModalConsentCreditBureau;
